import DashLoadStatusFormProperties from './DashLoadStatusFormProperties'
import DashLoadStatusApiUrls from 'src/apiUrls/ForwardHubApiUrls'
import { components } from 'cng-web-lib'
import React from 'react'

const {
  form: { CngViewForm }
} = components

function DashLoadStatusViewForm({
  showNotification,
  id,
  onFetchPreSuccess = () => {//this is intentional
  }
}) {
  return (
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      showNotification={showNotification}
      bodySection={
        <DashLoadStatusFormProperties.Fields
          disabled={true}
          showNotification={showNotification}
        />
      }
      formikProps={DashLoadStatusFormProperties.formikProps}
      toClientDataFormat={DashLoadStatusFormProperties.toClientDataFormat}
      toServerDataFormat={DashLoadStatusFormProperties.toServerDataFormat}
      fetch={{
        id: id,
        url: DashLoadStatusApiUrls.GET,
        onPreSuccess: onFetchPreSuccess
      }}
    />
  )
}

export default DashLoadStatusViewForm
